import type { AuthRepository, SnsSelectCommand } from '../repository/AuthRepository';
import type { AuthSession } from '../entity/AuthTypes';

export class SnsSelectUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: SnsSelectCommand): Promise<AuthSession> {
    if (!command.ticket) throw new Error('ticket is required');
    if (!command.user_id?.trim()) throw new Error('user_id is required');
    return this.repository.snsSelect(command);
  }
}
